export default "__VITE_ASSET__COorf6ps__"